import { GET_LOCKED_VISITS_START, GET_LOCKED_VISITS_SUCCESS, GET_LOCKED_VISITS_ERROR, UNLOCK_VISIT_ERROR, UNLOCK_VISIT_SUCCESS } from '../../actions/admin/lockedVisitsAction';
import _ from 'lodash';
const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    lockedVisits: []
}

export default (state = INIT_STATE, action) => {
    let newState;
    let index;
    let lockedVisits;
    switch (action.type) {
        case GET_LOCKED_VISITS_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case GET_LOCKED_VISITS_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, lockedVisits: action.lockedVisits.length > 0 ? [...action.lockedVisits] : [] };
        }
        case GET_LOCKED_VISITS_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }
        case UNLOCK_VISIT_SUCCESS: {
            newState = _.cloneDeep(state)
            newState.lockedVisits = newState.lockedVisits.filter(lockedVisit => lockedVisit.orderNo !== action.visit.orderNo);
            return { ...newState, error: '', message: '', loading: false }
        }
        case UNLOCK_VISIT_ERROR: {
            return { ...state, error: action.error, message: '', loading: false };
        }

        default:
            return state;
    }
}